function TypingIndicator({ names }: { names: string[] }) {
  if (!names.length) return null;
  const label = names.length === 1
    ? `${names[0]} is typing`
    : `${names.slice(0, 2).join(', ')} are typing`;

  return (
    <div className="flex items-center gap-2 px-4 pb-1">
      <div className="flex gap-0.5 items-end">
        {[0, 150, 300].map(d => (
          <span key={d} className="w-1.5 h-1.5 bg-gray-500 rounded-full animate-bounce"
            style={{ animationDelay: `${d}ms` }} />
        ))}
      </div>
      <span className="text-[11px] text-gray-500">{label}…</span>
    </div>
  );
}

export default TypingIndicator;
